import { AbstractCommand } from 'src/models/command';
import { Document } from 'src/models/document';

class DocumentDeleteCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Document_DeleteDocument';

	public constructor(document: Document) {
		super();
		this.parameters = {
			aggregateId: document.aggregateId,
			aggregateVersion: document.aggregateVersion,
		};
	}
}

export { DocumentDeleteCommand };
